import { useMemo } from "react";
import type { FormatterExample, FormatterTransforms } from "./types";
import CallToActionApiKey from "./CallToActionApiKey";
import ApiCallExampleCard, { type ApiCallExamplePayload } from "../api/ApiCallExampleCard";

type FormatterApiExampleProps = {
	example: FormatterExample;
	textOverride?: string;
};

type SnippetPayload = ApiCallExamplePayload;

function buildSnippetPayload(example: FormatterExample): SnippetPayload {
	const transforms: FormatterTransforms = { ...(example.transforms ?? {}) };
	const output = example.contentType === "text" ? "text" : "html";
	return {
		text: example.text,
		mode: example.contentType,
		output,
		options: example.options ?? {},
		transforms,
	};
}

function buildSnippetPayloadWithText(example: FormatterExample, text: string): SnippetPayload {
	const transforms: FormatterTransforms = { ...(example.transforms ?? {}) };
	const output = example.contentType === "text" ? "text" : "html";
	return {
		text,
		mode: example.contentType,
		output,
		options: example.options ?? {},
		transforms,
	};
}

export default function FormatterApiExample({ example, textOverride }: FormatterApiExampleProps) {
	const payload = useMemo(() => {
		const payload =
			typeof textOverride === "string"
				? buildSnippetPayloadWithText(example, textOverride)
				: buildSnippetPayload(example);
		return payload;
	}, [example, textOverride]);

	return (
		<ApiCallExampleCard
			payload={payload}
			footer={<CallToActionApiKey className="mt-8" />}
		/>
	);
}
